/**
 * Surfaces of `/studio/design-system`.
 *
 * `control-plane` / `assets` / `contracts` / `workbench` were removed with the
 * frozen 2026-06-21 evaluation fixture they rendered: three of them existed
 * only to display it, and `workbench` duplicated the theme editor that now
 * sits on `systems`. Every remaining tab reads live data.
 *
 * `ontology` outlived its own screen. #2619 removed its button and its render
 * branch and left it here, so `?tab=ontology` was still accepted from the URL
 * and drew a page with four tab buttons, none selected, and an empty body.
 * A vocabulary a URL accepts is only as good as the branches behind it —
 * `tab-vocabulary-closed.test.ts` now derives this list from the strip that
 * renders it, so the two cannot drift apart again.
 */
export type AgenticDesignSystemTab =
  | 'systems'
  | 'validation'
  | 'vocabulary'
  | 'briefings'

export const AGENTIC_DESIGN_SYSTEM_TABS: readonly AgenticDesignSystemTab[] = [
  'systems',
  'validation',
  'vocabulary',
  'briefings',
]

/** URL `?tab=` values are untrusted input — narrow before use. */
export function isAgenticDesignSystemTab(
  value: string,
): value is AgenticDesignSystemTab {
  return (AGENTIC_DESIGN_SYSTEM_TABS as readonly string[]).includes(value)
}
